// "Measure, Don't Guess" — the day I stopped tuning my RAG by vibes.
// Cold Compute / Neon kit. ~127s @ 30fps.
//
// GROUNDED in EAKC-MVP (2026-06-14 session — every number is real):
//   - The treadmill: each query type needed its own tweak; "retune 100s of times".
//   - First real eval baseline (the suite existed but was NEVER seeded): /admin/eval
//     → 22/23 pass, avg ~7s in prod, avg_score 0.4291. The honest signals were
//     latency + score, not pass/fail (keywords were loose → trivial passes).
//   - Cost hog: CONTEXTUAL_RETRIEVAL was ON → one gemini-2.5-flash call PER NEW
//     chunk at sync. ~17k new chunks in a week (mostly the 13.7k-chunk Hermes repo)
//     → ~$5 in a week. Turned OFF with a one-row runtime-config flip.
//   - FileDiscovery rescue: an always-on net-negative step (+1.7s, ~0 score gain)
//     with a 22P02 jsonb-filter bug (chunk_loc->path → chunk_loc->>path). Thin-gated.
//     The first "fix" REGRESSED latency (+1.7s) and the eval CAUGHT it (-1,155ms after
//     the gate, score held).
//   - The 41-second doubt: CRAG quality-gate spent 41s on one "standout" query
//     (Broader Search 17.6s + HyDE 21.5s) — two FULL extra retrieval passes — even
//     though retrieval was already correct (4 sources @ ~100%). Optimization: if
//     results are strong, skip escalation (grader stays ~2s); ambiguous → ONE cheap
//     broader pass; HyDE only when nothing was found.
// No fabricated numbers — 22/23, ~7s, 0.4291, ~$5, ~17k chunks, +1.7s, -1,155ms,
// 41s / 17.6s / 21.5s are the real session figures.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 420 }, //        0:00–0:14   the treadmill: retune 100s of times
  measure: { start: 420, duration: 510 }, //   0:14–0:31   first eval baseline · you can't fix what you don't measure
  cost: { start: 930, duration: 480 }, //      0:31–0:47   $5/week · a sticky note per chunk · one flag OFF
  thingate: { start: 1410, duration: 540 }, // 0:47–1:05   the rescue that padded everything · my own fix regressed · the eval caught it
  doubt: { start: 1950, duration: 540 }, //    1:05–1:23   the 41-second doubt · re-search the whole thing twice
  fix: { start: 2490, duration: 540 }, //      1:23–1:41   measure-then-cut · trust strong results · 41s → ~2s
  lesson: { start: 3030, duration: 480 }, //   1:41–1:57   stop tuning by vibes · delete layers until boring
  outro: { start: 3510, duration: 300 }, //    1:57–2:07
} as const;

export const TOTAL_DURATION = 3810; // 127s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
